"use strict";
// NOTE: This code was generated and should not be changed
Object.defineProperty(exports, "__esModule", { value: true });
exports.createMarketingResourceLinkClickNonAuth = void 0;
/**
 * A builder for MarketingResourceLinkClickNonAuth
 *
 * @param data - The event data
 * @return The formatted event data for MarketingResourceLinkClickNonAuthEvent
 */
function createMarketingResourceLinkClickNonAuth(data) {
    return {
        name: 'MarketingResourceLinkClickNonAuth',
        environments: ['browsernonauth'],
        data: data,
    };
}
exports.createMarketingResourceLinkClickNonAuth = createMarketingResourceLinkClickNonAuth;
//# sourceMappingURL=createMarketingResourceLinkClickNonAuth.js.map